import { MenuItem, TextField } from "@mui/material";
import { SafeDateTimePicker } from "components/SafeDateTimePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useTenantTranslation } from "hooks/formatters";
import { useEffect, useState } from "react";
import { installationInstant } from "./installationTimestamp";
import { ScrapEyeSensorRead } from "src/store/api/generatedApi";

dayjs.extend(utc);

export interface SensorInterval {
  sensorId: number | null;
  startedAt: string;
  endedAt: string | null;
}

interface SensorIntervalFieldsProps {
  sensors: ScrapEyeSensorRead[];
  interval: SensorInterval;
  onChange: (interval: SensorInterval) => void;
  onValidityChange: (valid: boolean) => void;
  startLabel: string;
  endLabel: string;
  disabled: boolean;
}

export const SensorIntervalFields = ({
  sensors,
  interval,
  onChange,
  onValidityChange,
  startLabel,
  endLabel,
  disabled,
}: SensorIntervalFieldsProps) => {
  const { t } = useTenantTranslation();
  const [startValid, setStartValid] = useState(true);
  const [endValid, setEndValid] = useState(true);
  useEffect(() => {
    onValidityChange(
      startValid &&
        endValid &&
        interval.sensorId != null &&
        dayjs.utc(interval.startedAt).isValid() &&
        (interval.endedAt == null ||
          installationInstant(interval.endedAt) >
            installationInstant(interval.startedAt))
    );
  }, [startValid, endValid, interval, onValidityChange]);

  return (
    <>
      <TextField
        select
        label={t("sensorNameLabel")}
        value={interval.sensorId ?? ""}
        disabled={disabled}
        onChange={(event) => {
          onChange({ ...interval, sensorId: Number(event.target.value) });
        }}
      >
        {sensors.map((sensor) => (
          <MenuItem key={sensor.id} value={sensor.id}>
            {`${sensor.name} (${sensor.serial_number ?? sensor.id})`}
          </MenuItem>
        ))}
      </TextField>
      <SafeDateTimePicker
        label={startLabel}
        timezone="UTC"
        ampm={false}
        disabled={disabled}
        value={dayjs.utc(interval.startedAt)}
        onInvalidDate={() => {
          setStartValid(false);
        }}
        onChange={(startedAt) => {
          setStartValid(startedAt != null);
          if (startedAt != null)
            onChange({ ...interval, startedAt: startedAt.toISOString() });
        }}
      />
      <SafeDateTimePicker
        label={endLabel}
        timezone="UTC"
        ampm={false}
        disabled={disabled}
        slotProps={{ field: { clearable: true } }}
        value={interval.endedAt == null ? null : dayjs.utc(interval.endedAt)}
        onInvalidDate={() => {
          setEndValid(false);
        }}
        onChange={(endedAt) => {
          setEndValid(true);
          onChange({ ...interval, endedAt: endedAt?.toISOString() ?? null });
        }}
      />
    </>
  );
};
